/**
 * The function checks if an item is a valid response from an API
 * @param value The item you want to check if it is a valid
 * @returns True if the response is Valid, False if it isn't
 */
export const isValidResponse = async (value: any) => {
    return value !== "" && value !== "null" && value !== undefined && value !== null && value !== "undefined";
};

/**
 * Allows Nav to utilize a Consumer Passed in Router Function
 * @param event The Click Event
 * @param clickHandler The Function the Consumer wishes to be called
 * @param path The Path that the Nav is Linking to
 */
export const handleClick = async (event: Event, clickHandler: Function, path: string) => {
    if (clickHandler) {
        let customPath = path;
        if (customPath.includes(window.location.origin)) {
            customPath = customPath.replace(window.location.origin, "");
            event.preventDefault();
            clickHandler(customPath);
        }
    }
};

/**
 * Capitalizes the first letter of a string
 * @param str The input string to capitalize
 * @returns String with first letter capitalized
 */
export const capitalizeBrandPaths = (str: string): string => {
    if (str === "gmc") {
        return str.toUpperCase();
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 *
 * @param navBarData The data of the nav to be rendered
 * @returns Object containing the currentDepartment and the modified Nav Data
 */
export const updateLiveLocationHelper = async (navBarData: Object) => {
    let navBarDataModified = navBarData;
    let currentDepartment = "";

    const currentLocation = window.location.href;
    const currentPath = window.location.origin + window.location.pathname;
    const currentSearch = window.location.search;

    // Identify the Current Department
    for (const departments in navBarDataModified) {
        if (
            currentLocation.includes(navBarDataModified[departments].location[0]) &&
            navBarDataModified[departments].location[1][0] === "*"
        ) {
            currentDepartment = departments;
        } else if (
            currentLocation.includes(navBarDataModified[departments].location[0]) &&
            navBarDataModified[departments].location[1].some((path: string) => currentLocation.includes(path))
        ) {
            currentDepartment = departments;
        }
    }

    // Identify if the Home Page is the current location
    if (currentPath === navBarDataModified[currentDepartment].home[1]) {
        navBarDataModified[currentDepartment].home[3] = true;
    } else {
        navBarDataModified[currentDepartment].home[3] = false;
    }

    // Identify if a link present in the Current Department is the current location
    for (const columnNumber in navBarDataModified[currentDepartment].columns) {
        for (const linkContent in navBarDataModified[currentDepartment].columns[columnNumber]) {
            // Ignore the element if it is not an Array
            if (Array.isArray(navBarDataModified[currentDepartment].columns[columnNumber][linkContent])) {
                if (
                    currentLocation.includes(
                        navBarDataModified[currentDepartment].columns[columnNumber][linkContent][1]
                    )
                ) {
                    if (
                        currentLocation === navBarDataModified[currentDepartment].columns[columnNumber][linkContent][1]
                    ) {
                        navBarDataModified[currentDepartment].columns[columnNumber][linkContent][3] = true;
                    } else if (
                        currentPath === navBarDataModified[currentDepartment].columns[columnNumber][linkContent][1]
                    ) {
                        navBarDataModified[currentDepartment].columns[columnNumber][linkContent][3] = true;
                    } else if (
                        currentSearch.includes(
                            navBarDataModified[currentDepartment].columns[columnNumber][linkContent][1]
                        )
                    ) {
                        navBarDataModified[currentDepartment].columns[columnNumber][linkContent][3] = true;
                    } else {
                        navBarDataModified[currentDepartment].columns[columnNumber][linkContent][3] = false;
                    }
                } else {
                    navBarDataModified[currentDepartment].columns[columnNumber][linkContent][3] = false;
                }
            }
        }
    }

    return { currentDepartment: currentDepartment, navBarData: navBarDataModified };
};
